import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bb3t3nl0h3: FaireBrandEntity = {
  token: "b_bb3t3nl0h3",
  type: "brand",
  name: "Wilderness Maven Apothecary",
  avatarUrl:
    "https://cdn.faire.com/fastly/43c53aad5d590800c7da89cde349a1133d48c272e12e072e954b91dd87bfdacb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1c224d3cf0a6e753b025c7cf84bb436ada7d46370fbeb4a3b417f340254cd7a9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/43c53aad5d590800c7da89cde349a1133d48c272e12e072e954b91dd87bfdacb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1c224d3cf0a6e753b025c7cf84bb436ada7d46370fbeb4a3b417f340254cd7a9.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 175,
  rating: 5,
  reviewCount: 42,
  isTopShop: true,
  isInsider: true,
  description:
    "Working in communion with the land and harnessing the potency of each passing season, at Wilderness Maven Apothecary we craft herbalist-formulated botanical skin care and powerful wellness formulas. Using raw botanicals mindfully and sustainably wild-harvested from our bioregion, grown on our farm, or sourced from other small farmers, we intentionally formulate and carefully extract the essence of each plant to create dynamic and nutritionally exceptional skin care, teas, tinctures, and other wellness formulas.\n\nEach of our offerings is a testament to the art of slow creation, where ancient traditions meet modern botanical science and highlight the vitality of our ingredients. The result is a collection of exceptional offerings that provide vibrant and powerful support for the skin, body, and spirit, all while maintaining a deep reverence for the natural world. \n\nEarth medicine is ancient, powerful, and capable. Plants do not offer poor or weak medicine. They are powerfully bioactive allies that partner with our bodies in alchemical ways to support balance and wellness. We must approach each seed, each bloom, each stem, as sacred and alive — full of spirit and energy alongside the bioactive components that plants offer our human systems.\n\nIt is the greatest gift to be able to mindfully craft these beautiful botanical goods for the world.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:24.554Z",
    importedBy: "entity-db-cli",
  },
};
